import Riot from 'riot';
import $ from 'jquery';
import { ActionTypes } from '../constants/ActionTypes';
import { Dispatcher } from '../dispatcher/Dispatcher';
import { UserInitialiser } from '../initialisers/UserInitialiser';

const CHANGE_EVENT = 'update';

// State
const _users = {};
let _currentUser = null;

// Event emitter
const _observable = {};
Riot.observable(_observable);

// Helper functions to manipulate data
const _addUser = (user) => {
  if (_users[user.profileName] === undefined) {
    _users[user.profileName] = {};
  }
  $.extend(true, _users[user.profileName], user);
};

// Interface to view-controllers
export const UserStore = {
  dispatchToken: null,

  registerChangeCallback: (callback) => {
    _observable.on(CHANGE_EVENT, callback);
  },

  unregisterChangeCallback: (callback) => {
    _observable.off(CHANGE_EVENT, callback);
  },

  getCurrentUser: () => {
    return UserStore.getUser(_currentUser);
  },

  getUser: (profileName) => {
    if (_users[profileName]) {
      const result = {};
      $.extend(true, result, _users[profileName]);
      return result;
    } else {
      return null;
    }
  },
};

// Responses to actions from dispatcher
UserStore.dispatchToken = Dispatcher.register((action) => {
  // eslint-disable-next-line default-case
  switch (action.type) {
    case ActionTypes.USER_UPDATE:
      _addUser(action.user);
      _observable.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.USER_UPDATE_MANY:
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const profileName in action.users) {
        _addUser(action.users[profileName]);
      }
      _observable.trigger(CHANGE_EVENT);
      break;

    case ActionTypes.USER_SET_CURRENT:
      _currentUser = action.profileName;
      _observable.trigger(CHANGE_EVENT);
      break;
  }
});

// Load initial data
UserInitialiser.initialise();
